import axios from '~/utils/axios';

export const getProcessingFlows = () => {
  return axios.get<string[]>(`processingFlows`);
};
